import { ofType } from 'redux-observable';
import { get, omit } from 'lodash-es';
import { from, of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { ajax, AjaxError } from 'rxjs/ajax';
import { CREATE_RECORD_API } from "../../constants/routes";
import { CREATE_RECORD } from './types';

export const CreateRecordEpic = (action$: any, state$: any,base64Image:string) =>
  action$.pipe(
    ofType(CREATE_RECORD.name),
    mergeMap((action) => {
      const token = localStorage.getItem('verificationToken');
      return from(
        ajax({
          url: CREATE_RECORD_API,
          body: get(action, 'payload', {}),
          
          method: 'POST',
          async: false,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
          }
        })
      ).pipe(
        map((response) => CREATE_RECORD.successAction(response, action)),
        catchError((error: AjaxError) => of(CREATE_RECORD.failureAction(error, action)))
      );
    })
  );